import backofficeService from '@/api/backoffice'

export default {
  /**
   * Get list of products
   * @param {*} params
   * @param {*} params.limit
   * @param {*} params.offset
   * @param {*} params.search
   * @param {*} params.local Add LocalData to products
   */
  getAll(params) {
    return backofficeService.Api().get('purchasePayment', { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },


  groupByCustomer(params) {
    return backofficeService.Api().get('purchasePayment/groupByCustomer', { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  
  groupByPaymentMethod(params) {
    return backofficeService.Api().get('purchasePayment/purchasePaymentType', { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },


  /**
   * Get specific product
   * @param {*} id
   * @param {*} params
   * @param {*} params.local Add LocalData to product
   */
  getById(id, params = {}) {
    return backofficeService.Api().get(`purchasePayment/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  getDetailById(id, params = {}) {
    return backofficeService.Api().get(`/purchasePaymentDetail/payment/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  last(params = {}) {
    return backofficeService.Api().get(`purchasePaymentDetail/last`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  
  /**
   * Create a product. Will also initiate location data
   * @param {*} data
   */
  create(data) {
    return backofficeService.Api().post('purchasePayment', data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Update specific product
   * @param {*} id
   * @param {*} data
   */
  update(id, data) {
    return backofficeService.Api().put(`purchasePayment/${id}`, data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Delete product
   * @param {} id
   * @param {*} params
   */
  delete(id, params) {
    return backofficeService.Api().delete(`purchasePayment/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  deletePaymentDetail(id, params) {
    return backofficeService.Api().delete(`purchasePaymentDetail/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

}
